import { FeatureCollection, MultiPolygon, Point, Polygon } from '@turf/turf';
import GeoData, { IGeoDataProps } from 'designSystem/Inputs/GeoData/GeoData';
import { FieldProps, useField } from 'formik';
import React, { FC } from 'react';

const GeoDataField: FC<
  Omit<IGeoDataProps, 'value' | 'onChange'> &
    FieldProps<FeatureCollection<Polygon | Point | MultiPolygon>>
> = ({ field: { value, name }, ...props }) => {
  const [, , { setValue }] = useField<
    FeatureCollection<Polygon | Point | MultiPolygon> | undefined
  >(name);

  return <GeoData defaultValue={value} {...props} onChange={setValue} />;
};

export default GeoDataField;
